<template>
    <div>
        <ExpJur v-if="reporte.aiclave == 1"></ExpJur>
        <RCMedico v-if="reporte.aiclave == 5"></RCMedico>
        <RLV v-if="reporte.aiclave == 23"></RLV>
        <Robo v-if="reporte.aiclave == 24"></Robo>
        <Civil v-if="reporte.aiclave == 27"></Civil>
    </div>
</template>
<script>
import { mapGetters, mapState, mapMutations } from 'vuex';
import Asistencia from '@/services/AsistenciaGeneral/AsistenciaGeneral.service.js';
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import ExpJur from '@/components/pages/ExpJur/Detalle.vue';
import Robo from '@/components/pages/Robo/Detalle.vue';
import RLV from '@/components/pages/RLV/Detalle.vue';
import RCMedico from '@/components/pages/ExpJur/Detalle.vue';
import Civil from '@/components/pages/Civil/Detalle.vue'

export default {
    components: {
        ExpJur,
        Robo,
        RLV,
        RCMedico,
        Civil
    },
    data() {
        return {
            reporte: {},
        }
    },
    methods: {

    },
    async mounted() {
        this.reporte = await MetodosGenerales.obtenerSessionReporte("reporte");
    }
}
</script>